// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"6f19456c","551":"07c724d9","640":"b58fbf5d","645":"fa85245a"}[chunkId] + ".chunk.js";
};